import { render } from "./AmountField.vue?vue&type=template&id=0d3d9b72"
import script from "./AmountField.vue?vue&type=script&lang=js"
export * from "./AmountField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__